<div class="row">
  <div class="col-12 col-md-10 offset-md-1">

    <div *ngIf="isAskForLoginState"
         class="account-login-prompt card text-center">
      <div class="card-body d-flex flex-column align-items-center p-5">
        <p class="account-login-prompt-title h5 fw-bold"
           [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ASK-FOR-LOGIN-PROMPT.QUESTION'">
        </p>
        <button class="account-login-prompt-login btn btn-primary px-5"
                (click)="signIn()"
                type="button"
                [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ASK-FOR-LOGIN-PROMPT.BUTTON-LOGIN'">
        </button>

        <a class="account-login-prompt-continue"
           href="#"
           (click)="setAskLoginState(false)"
           [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ASK-FOR-LOGIN-PROMPT.BUTTON-CONTINUE'">
        </a>
      </div>
    </div>

    <ng-container *ngIf="!isAskForLoginState">

      <div *ngIf="!isLoggedIn"
           class="mb-4">
        <a href="#"
           (click)="setAskLoginState(true)"
           class="btn btn-link dvi-themed-text-color py-2 ps-0 pe-2 border-0 d-flex align-items-center">
          <i-feather name="arrow-left"
                     class="sm me-2"></i-feather>
          <span [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ASK-FOR-LOGIN-PROMPT.BUTTON-BACK'"></span>
        </a>
      </div>

      <span class="h5 fw-bold mb-3 d-block"
            [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.LABEL-FILL-IN-FORM'"></span>
      <div *ngIf="!shouldShowFormFields"
           [@inOutAnimation]>
        <div class="text-secondary mb-3">
          <span class="notranslate">
            <span>{{ parentForm.controls.customerData.controls.firstName.value }}&nbsp;</span>
            <span *ngIf="parentForm.controls.customerData.controls.nameInfix">{{ parentForm.controls.customerData.controls.nameInfix.value }}&nbsp;</span>
            <span>{{ parentForm.controls.customerData.controls.lastName.value }}</span>
            <br>
            <span>{{ parentForm.controls.customerData.controls.email.value }}</span><br>
            <span>
            </span>
            {{ countryPhoneCode + parentForm.controls.customerData.controls.mobileNumber.value }}
          </span>
          <br>
          <a href="#"
             (click)="toggleEditMode(); false">
            {{ 'BOOKING-PART.STEPS.CUSTOMER-DATA.EDIT-CUSTOMER-DATA-BUTTON-TEXT' | translate }}
          </a>
        </div>
      </div>

      <app-customer-data-form [@inOutAnimation]
                              [isFormSubmitted]="isFormSubmitted"
                              [showFields]="shouldShowFormFields"
                              [emailInputDisabled]="isLoggedIn"
                              [passwordInputVisible]="!isLoggedIn"
                              [showCheckboxDontCreateAccount]="true"
                              [remarksInputVisible]="true"
                              (formSubmitted)="formSubmitted($event)">
        <div *ngIf="isOnlinePaymentAvailable"
             class="my-5">
          <span class="h5 fw-bold mb-3 d-block"
                [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.PAYMENT-METHOD.DESCRIPTION'"></span>
          <app-choose-payment-method>
          </app-choose-payment-method>
        </div>
        <ng-container [formGroup]="parentForm">
          <fieldset *ngIf="isCustomerAdviceRequestEnabled"
                    class="my-5">
            <span class="h5 fw-bold mb-3 d-block"
                  [translate]="'BOOKING-PART.CUSTOMER-PRODUCT-ADVICE.LABEL'">
            </span>
            <div class="form-check form-check-inline">
              <input type="radio"
                     id="customerAdviceInputYes"
                     name="adviceRequested"
                     class="form-check-input"
                     [value]="!!YesNoChoice.Yes"
                     formControlName="adviceRequested">
              <label class="form-check-label"
                     for="customerAdviceInputYes"
                     [translate]="'BOOKING-PART.CUSTOMER-PRODUCT-ADVICE.INPUT-RADIO-YES'"></label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio"
                     id="customerAdviceInputNo"
                     name="adviceRequested"
                     class="form-check-input"
                     [value]="!!YesNoChoice.No"
                     formControlName="adviceRequested">
              <label class="form-check-label"
                     for="customerAdviceInputNo"
                     [translate]="'BOOKING-PART.CUSTOMER-PRODUCT-ADVICE.INPUT-RADIO-NO'"></label>
            </div>
          </fieldset>
        </ng-container>

        <div class="text-secondary text-center terms-and-conditions-text">
          <span
                [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.CUSTOMER-READ-AND-ACCEPTED-NOTE.BY-CLICKING-NEXT-I-ACCEPT'"></span>&nbsp;<a
             href="{{'SHARED.LINKS.DISCLAIMER.LINK' | translate}}"
             target="_blank"
             [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.CUSTOMER-READ-AND-ACCEPTED-NOTE.DISCLAIMER'"></a>
          <span *ngIf="onlineBookingTermsAndConditions">,</span>&nbsp;<a *ngIf="onlineBookingTermsAndConditions"
             href="{{ onlineBookingTermsAndConditions }}"
             target="_blank"
             [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.CUSTOMER-READ-AND-ACCEPTED-NOTE.ONLINE-BOOKING-TERMS-AND-CONDITIONS'"></a>
          <span *ngIf="onlineBookingTermsAndConditions">&nbsp;</span>
          <span [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.CUSTOMER-READ-AND-ACCEPTED-NOTE.AND'"></span>&nbsp;<a
             href="{{'SHARED.LINKS.PRIVACY-POLICY.LINK' | translate}}"
             target="_blank"
             [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.CUSTOMER-READ-AND-ACCEPTED-NOTE.PRIVACY-POLICY'"></a>.
        </div>

        <div [@inOutAnimation]
             class="text-danger text-center mt-4"
             *ngIf="isFormSubmitted && parentForm.invalid"
             [translate]="'BOOKING-PART.STEPS.CUSTOMER-DATA.ERROR-FORM-INVALID'">
        </div>

        <div class="d-flex justify-content-center mt-4">
          <button class="button-make-appointment btn btn-primary btn-lg px-5"
                  (click)="bookVisit()">
            {{ 'BOOKING-PART.STEPS.CUSTOMER-DATA.MAKE-APPOINTMENT-BUTTON-TEXT' | translate }}
          </button>
        </div>

      </app-customer-data-form>
    </ng-container>

  </div>
</div>
